import registerComponent from './register_component';

// Import global analytics
import { dtmLoaded } from './analytics/dtm_helper';

import './helpers/ADAKeyboardHelper';
import './helpers/navHelper';
import './helpers/checkDeviceType';

// Grab UTM codes from the url and store them in the session so they can be utilized later for tracking purposes
import './session/utm';

import NMSearchPage from './components/nm_search_page.component';
import NMUserLogin from './components/nm_user_login.component';
import NMLoginButton from './components/nm_login_button.component';

dtmLoaded();

registerComponent('nm-search-page', NMSearchPage);
registerComponent('nm-user-login', NMUserLogin);
registerComponent('nm-login-button', NMLoginButton);